<template>
    <transition name="fade">
        <div v-if="show" class="cookies-container">
            <div class="cookies-content">
                <p>
                    Utilizamos cookies para melhorar a sua experiência no site. Ao continuar navegando, você concorda
                    com a nossa
                    <a style="cursor: pointer" @click="openWindow('pageTermsOfUsePrivacy')">Política de Privacidade</a>
                    e com a nossa
                    <a style="cursor: pointer" @click="openWindow('pageTermsOfUseCookies')"
                        >Política de uso Cookies.</a
                    >
                </p>
                <eg-button @click="closeCoockie()">
                    Entendi
                </eg-button>
            </div>
        </div>
    </transition>
</template>

<script>
import { setCookie } from '@/services/cookie-service';
import { KEYS } from '@/utils/constants';
export default {
    data: () => ({
        show: false
    }),
    created() {
        const name = this.$route.name;
        if (
            name == 'LandingPage' ||
            name == 'CompetitionDashboardGuest' ||
            name == 'Signup' ||
            name == 'Login' ||
            name == 'ContactUs' ||
            name == 'CondoTechsLandingpage' ||
            name == 'CondoTechsContactUs' ||
            name == 'CondoTechsDetails' ||
            name == 'OffersDetailsGuest' ||
            name == 'GuestContactNetwork'
        ) {
            this.show = !this.$cookies.get(KEYS.ACCEPETD_COOKIES);
        }
    },
    methods: {
        closeCoockie() {
            const days = 720;
            setCookie(KEYS.ACCEPETD_COOKIES, true, days);
            this.show = false;
        },
        openWindow(name) {
            const routeData = this.$router.resolve({
                name
            });
            window.open(routeData.href, '_blank');
        }
    }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.cookies-container {
    color: #222;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
        'Helvetica Neue', sans-serif;
    position: fixed;
    width: 100%;
    bottom: 1rem;
    z-index: 1000;
}

.cookies-content {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    background: white;
    max-width: 80%;
    border-radius: 5px;
    padding: 1rem;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 0.5rem;
    opacity: 0;
    transform: translateY(1rem);
    animation: slideUp 0.5s forwards;
}

@keyframes slideUp {
    to {
        transform: initial;
        opacity: initial;
    }
}

.cookies-pref label {
    margin-right: 1rem;
}

@media (max-width: 768px) {
    .cookies-content {
        grid-template-columns: 1fr;
    }
}
</style>
